import { Injectable } from '@angular/core';
import { NoteVisibilityType } from '../../../components/notes/notes.interface';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';

@Injectable({
  providedIn: 'root'
})
export class NotesService {
  get baseUrl(): any {
    return `${this.dataCollectorService.baseurl()}`;
  }
  get notesUrl(): string{
    return `${this.baseUrl}/notes`;
  }
  get noteAttachmentUrl(): string{
    return `${this.baseUrl}/note_attachment`;
  }
  get notesApiUrls(): any{
    return {
      uploadUrl: `${this.baseUrl}/misc/upload`,
      downloadUrl: `${this.baseUrl}/misc/download`,
      deleteUrl: `${this.baseUrl}/misc/delete`
    };
  }

  constructor(private dataCollectorService: DataCollectorService) {
  }

  updateUrl(url: string, noteUID: string): string {
    return `${url}/${noteUID}`;
  }

  getNoteVisibility(note: any): NoteVisibilityType {
    if (note && note.is_private) {
      return NoteVisibilityType.PRIVATE;
    } else if (note && !note.visible_to_customer) {
      return NoteVisibilityType.INTERNAL;
    }
    return NoteVisibilityType.PUBLIC;
  }
}
